import AudienceHubPage from "@/components/AudienceHubPage";
import { IMG } from "@/lib/data";
import { STATUS } from "@/lib/status";

const PROGRAMMES = [
  {
    id: "level-up-xr",
    title: "Level Up XR Programme",
    desc: "Our flagship 16–25 programme — XR, AI storytelling, performance, employability. Accredited pathways into University of Kent & Rose Bruford.",
    image: IMG.levelUp,
    focal: "50% 40%",
    status: STATUS.BOOKING_OPEN,
    href: "/level-up-xr",
    eyebrow: "16–25 · Applications open",
  },
  {
    id: "home-education",
    title: "Home Education Programme",
    desc: "Wednesday + Thursday programme for home-educating young people — heritage, XR, creative play.",
    image: IMG.heroPortal,
    focal: "center",
    status: STATUS.BOOKING_OPEN,
    href: "/home-education",
    eyebrow: "6–16 · Booking open",
  },
  {
    id: "waterline",
    title: "Waterline",
    desc: "A youth-led immersive piece exploring climate, migration and the bodies of water that carry us.",
    image: IMG.wellness,
    focal: "center",
    status: STATUS.IN_DEVELOPMENT,
    eyebrow: "16–25 · In development",
  },
  {
    id: "kulture-lab-residencies",
    title: "Kulture Lab Residencies",
    desc: "Paid residencies in our Lab for emerging creators of colour. Open seasonally.",
    image: IMG.xrTheatre,
    focal: "center",
    status: STATUS.REGISTER_INTEREST,
    eyebrow: "18–30 · Register interest",
  },
  {
    id: "after-school-clubs",
    title: "After School Clubs (11–14)",
    desc: "Late-stage after-school clubs aimed at older teens transitioning to college or sixth-form.",
    image: IMG.dance1,
    focal: "50% 40%",
    status: STATUS.LIVE_NOW,
    href: "/after-school-clubs",
    eyebrow: "11–14 · Live now",
  },
  {
    id: "neet-pathway",
    title: "NEET Creative Pathway",
    desc: "Bespoke pathway for young people not in education, employment or training — Medway focus.",
    image: IMG.immersiveNights,
    focal: "center",
    status: STATUS.REGISTER_INTEREST,
    eyebrow: "16–24 · Register interest",
  },
];

export default function Youth() {
  return (
    <AudienceHubPage
      testIdRoot="youth"
      pageSource="youth"
      seo={{
        title: "Creative Careers Programme for 16–25 — Temple of Kulture",
        description:
          "Level Up XR, accredited pathways into University of Kent and Rose Bruford, NEET support in Medway, and Kulture Lab residencies for emerging creators of colour.",
        image: IMG.levelUp,
      }}
      hero={{
        eyebrow: "For Young People · 16–25",
        headline: "Where young creatives become world-builders.",
        subhead:
          "Level Up XR, Home Education pathways, Kulture Lab residencies and NEET support — accredited routes into the creative industries, rooted in diaspora storytelling.",
        image: IMG.levelUp,
        focal: "50% 40%",
        primaryCta: { label: "Apply to Level Up", to: "/level-up-xr" },
      }}
      identity={{
        eyebrow: "Why young people choose TOK",
        headline: "We make space for the brilliance the industry overlooks.",
        body:
          "Most creative-industry programmes weren't built with global majority young people in mind. Ours are. We pay cohort members where we can, we accredit through real universities, and we keep our doors open for those moving sideways into creative work — not just those with a linear path.",
      }}
      programmes={PROGRAMMES}
      trustLine="Programme partners include University of Kent · Rose Bruford College · Medway Council · Arts Council England. 84% of Level Up graduates progress into paid creative work, further study or industry placements within 6 months."
      faqs={[
        {
          q: "Who can apply to Level Up?",
          a: "Young people aged 16–25 with an interest in XR, immersive storytelling, performance, AI, projection or creative tech. No prior experience required — we'll meet you where you are.",
        },
        {
          q: "Is Level Up free?",
          a: "Yes. Level Up is fully funded for participants. Selected cohort members also receive a paid bursary covering travel and materials.",
        },
        {
          q: "Where do you run programmes?",
          a: "Most run from our Medway base, with London and Kent satellite sessions. Online elements available where appropriate.",
        },
        {
          q: "What if I'm not in education or training?",
          a: "Our NEET Creative Pathway is built specifically for you. It's a softer entry point with one-to-one support before transitioning into Level Up or paid creative work.",
        },
      ]}
      finalCta={{
        eyebrow: "Next cohort intake",
        headline: "Applications open monthly.",
        body: "Drop your email and we'll send the next application window the moment it opens.",
        label: "Get notified",
        to: "/level-up-xr",
        bullets: [
          "Fully funded for participants",
          "Accredited pathways",
          "Paid bursary slots available",
        ],
      }}
      stayWhatsAppCopy={{
        headline: "GET NOTIFIED WHEN APPLICATIONS OPEN",
        tagline: "Application windows, casting calls and paid creative opportunities — straight to your WhatsApp.",
        bullets: [
          "Application windows & deadlines",
          "Open days and taster sessions",
          "Casting calls and paid creative work",
          "Funding and bursary announcements",
          "Pathway updates into University of Kent & Rose Bruford",
        ],
      }}
    />
  );
}
